import { DesktopAuthProvider, useAuthentication as useDesktopAuthentication } from './AuthProvider.desktop';
import { MobileAuthProvider, useAuthentication as useMobileAuthentication } from './AuthProvider.mobile';

export const AuthProvider =
  process.env.NEXT_PUBLIC_IS_MOBILE === 'true' ? MobileAuthProvider : DesktopAuthProvider;

// Both files still export their own `useAuthentication` from separate
// AuthContext instances. Since only one of the two providers is ever
// bundled/rendered per build (selected above), re-export whichever one
// matches so the rest of the app can keep doing:
//   import { useAuthentication } from '@providers/AuthProvider';
export const useAuthentication =
  process.env.NEXT_PUBLIC_IS_MOBILE === 'true' ? useMobileAuthentication : useDesktopAuthentication;
